import type { FC, PropsWithChildren } from 'react';
import { Container } from '@mantine/core';
import type { ContainerProps } from '@mantine/core';
import styles from './PageContainer.module.css';
import { cn } from '@/utils';

export const PageContainer: FC<PropsWithChildren<ContainerProps>> = ({
    children,
    className,
    ...rest
}) => {
    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Container fluid className={cn(styles.container, className)} {...rest}>
            {children}
        </Container>
    );
};
